// dev/frontend/src/App.jsx
import { Link, NavLink, Route, Routes } from "react-router-dom";
import Stats from "./pages/Stats.jsx";
import Sightings from "./pages/Sightings.jsx";
import TopPlates from "./pages/TopPlates.jsx";
import LastSeen from "./pages/LastSeen.jsx";

function NavBar() {
  return (
    <header className="app-header">
      <div className="brand">
        <Link
          to="/"
          className="brand-link"
          style={{ fontSize: 22, fontWeight: 800 }}
        >
          Westminster Traffic
        </Link>
        {/* removed DEV badge */}
      </div>
      <nav className="nav">
        <NavLink to="/" end className="nav-link">Stats</NavLink>
        <NavLink to="/last-seen" className="nav-link">Last-Seen</NavLink>
        <NavLink to="/top-plates" className="nav-link">Top Plates</NavLink>
        {/* <NavLink to="/sightings" className="nav-link">Sightings</NavLink> */}
      </nav>
    </header>
  );
}

export default function App() {
  return (
    <div className="app">
      <NavBar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Stats />} />
          <Route path="/last-seen" element={<LastSeen />} />
          <Route path="/top-plates" element={<TopPlates />} />
          <Route path="/sightings" element={<Sightings />} />
          <Route path="*" element={<Placeholder title="Not found" />} />
        </Routes>
      </main>
      <footer className="footer">© Westminster Traffic</footer>
    </div>
  );
}

function Placeholder({ title }) {
  return (
    <section className="card">
      <h2>{title}</h2>
      <p>This page will be implemented after the Stats page.</p>
    </section>
  );
}
